import { gql } from "@apollo/client";

export const GET_INCIDENTS = gql`
  query GetIncidents($buildingId: uuid, $limit: Int = 10, $offset: Int = 10) {
    Incident(
      where: {
        Shift_Gaurd: { Shift: { Building: { Id: { _eq: $buildingId } } } }
      }
      order_by: { StartDateTime: desc }
      limit: $limit
      offset: $offset
    ) {
      Description
      Resolved
      StartDateTime
      Title
      ImageUrl
      Lat
      Long
      Shift_Gaurd {
        Gaurd {
          GaurdFirstName
        }
      }
      Id
    }
    Incident_aggregate(
      where: {
        Shift_Gaurd: { Shift: { Building: { Id: { _eq: $buildingId } } } }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const RESOLVE_INCIDENT = gql`
mutation ResolveIncident($id: uuid, $Resolution: String = "") {
  update_Incident(where: {Id: {_eq: $id}}, _set: {Resolution: $Resolution, Resolved: true}) {
    affected_rows
  }
}
`
